import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';

import { ButtonsModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { ChartModule } from '@progress/kendo-angular-charts';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TemplateModule } from '../template/template.module';
import { TemplateSettingDialogComponent } from './template-setting-dialog.component';
import { TemplateSettingConfigComponent } from './template-setting-config/template-setting-config.component';
import { TemplateSettingFieldsComponent } from './template-setting-fields/template-setting-fields.component';
import { TemplateSettingLayoutComponent } from './template-setting-layout/template-setting-layout.component';
import { TagInputModule } from 'ngx-chips';
import { TemplateSettingLayoutModule } from './template-setting-layout/template-setting-layout.module';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        TagInputModule,
        // kendo
        ButtonsModule,
        ChartModule,
        DateInputsModule,
        DropDownButtonModule,
        DropDownsModule,
        InputsModule,
        PopupModule,
        TooltipModule,
        DialogsModule,
        TemplateModule,
        TemplateSettingLayoutModule
    ],
    declarations: [
        TemplateSettingDialogComponent,
        TemplateSettingConfigComponent,
        TemplateSettingFieldsComponent,
        TemplateSettingLayoutComponent,
    ],
    exports: [
        TemplateSettingDialogComponent,
    ]
})
export class TemplateSettingDialogModule { }
